// extracted by mini-css-extract-plugin
export default {"fof":"styles_fof__uF2r5"};